export default __webpack_public_path__ + "static/media/ad_weboffice_kr_300x250@2x.d8f77dbc.png";